const TOKEN_PARAMS = ['jwt_token', 'admin_token'];

const stripTokenParams = (path: string): string => {
  const strippedUrl = new URL(path, 'http://localhost');
  for (const tokenParam of TOKEN_PARAMS) strippedUrl.searchParams.delete(tokenParam);
  return strippedUrl.pathname + strippedUrl.search;
};

export default stripTokenParams;
